import { render } from "./PlatformDeclaration.vue?vue&type=template&id=5939cdf2&scoped=true"
import script from "./PlatformDeclaration.vue?vue&type=script&lang=js"
export * from "./PlatformDeclaration.vue?vue&type=script&lang=js"

import "./PlatformDeclaration.vue?vue&type=style&index=0&id=5939cdf2&lang=scss&scoped=true"

import exportComponent from "/var/www/html/OrderUser/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5939cdf2"]])

export default __exports__